module.exports = __webpack_public_path__ + "img/swipe2.a64bce25.png";